<template>
  <div>
    <Modal class="lg-modal" title="Contacts" :open="open" @close="$emit('close')">
      <table class="table">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Prenom</th>
            <th>Mail</th>
            <th>Tel</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="contact of contacts" :key="contact.Id">
            <td>
              <span v-if="updatingContactId !== contact.Id">
                {{contact.Nom}}
              </span>
              <input class="form-control" v-else type="text" v-model="updatingContact.Nom" />
            </td>
            <td>
              <span v-if="updatingContactId !== contact.Id">
                {{contact.Prenom}}
              </span>
              <input class="form-control" v-else type="text" v-model="updatingContact.Prenom" />
            </td>
            <td>
              <span v-if="updatingContactId !== contact.Id">
                {{contact.Mail}}
              </span>
              <input class="form-control" v-else type="email" v-model="updatingContact.Mail" />
            </td>
            <td>
              <span v-if="updatingContactId !== contact.Id">
                {{contact.Tel}}
              </span>
              <input class="form-control" v-else type="tel" v-model="updatingContact.Tel" />
            </td>
            <td>
              <div class="btn-group" v-if="$store.state.self.isAdmin">
                <button class="btn btn-warning" v-if="updatingContactId !== contact.Id" @click="updatingContactId = contact.Id;updatingContact=contact"><font-awesome-icon icon="pen"></font-awesome-icon></button>
                <button class="btn btn-warning" v-else @click="updatingContactId = -1;updatingContact = {}"><font-awesome-icon icon="undo"></font-awesome-icon></button>
                <button class="btn btn-danger" v-if="updatingContactId !== contact.Id" @click="deleteContact(contact.Id)"><font-awesome-icon icon="times"></font-awesome-icon></button>
                <button class="btn btn-success" v-else-if="$store.state.self.isAdmin && updatingContactId === contact.Id" @click="updateContact(contact.Id)"><font-awesome-icon icon="check"></font-awesome-icon></button>
              </div>
            </td>
          </tr>
          <tr>
            <td><input class="form-control" type="text" v-model="creatingContact.Nom" /></td>
            <td><input class="form-control" type="text" v-model="creatingContact.Prenom" /></td>
            <td><input class="form-control" type="email" v-model="creatingContact.Mail" /></td>
            <td><input class="form-control" type="tel" v-model="creatingContact.Tel" /></td>
            <td><button class="btn btn-success w-100 text-center" @click="updateContact()">Ajouter</button></td>
          </tr>
        </tbody>
      </table>
    </Modal>
  </div>
</template>

<script>
  import Modal from "@/components/Modal"

  import { getFrsHRContact, updateFrsHRContact, deleteFrsHRContact } from "@/utils/frsHR"

  export default {
    name: "FrsHRContactModal",
    components: {
      Modal
    },
    props: {
      open: Boolean,
      idFrsHR: Number
    },
    data() {
      return {
        contacts: [],
        creatingContact: {},
        updatingContactId: -1,
        updatingContact: {}
      }
    },
    mounted() {
      this.fetchData();
    },
    computed: {
    },
    methods: {
      fetchData() { // récupère la liste des contacts du frs sélectionné (id envoyé via props)
        getFrsHRContact(this.idFrsHR).then(res => {
          res.sort((a, b) => a.Nom < b.Nom ? -1 : 1);
          this.contacts = res
          this.creatingContact = {}
          this.updatingContact = {}
          this.updatingContactId = -1
        });
      },
      updateContact(contactId = -1) { // Créé un nouveau contact quand id = -1, update un contact quand l'id est renseigné
        const newContact = contactId === -1 ? this.creatingContact : this.updatingContact
        updateFrsHRContact(this.idFrsHR, newContact.Nom || "", newContact.Prenom || "", newContact.Mail || "", newContact.Tel || "", contactId).then(this.fetchData)
      },
      deleteContact(id) { // Supprime un contact
        const validation = window.confirm("Voulez-vous vraiment supprimer ce contact ?")
        if (validation) deleteFrsHRContact(id).then(this.fetchData)
      }
    }
  }
</script>

<style scoped>

  table tbody {
    border-top-width: 1px !important;
  }

  table tr:last-child, table tr:last-child td {
    border-bottom: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/FrsHRContactModal.vue